<template>
  <div id="defaultId1" class="company_detail">
    <gui_card
      v-if="ImporttableData?.length > 0"
      id="ge6845"
      class="uc1096 pb20"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head">{{ $t("Lawsutis.Litigations") }} </span>
        </h2>
        <div class="table-biao">
          <el-table
            :data="ImporttableData"
            style="width: 100%"
            empty-text="No Data"
            class="table_height_30 table_font_size_14 table_contentHeight_40"
          >
            <el-table-column
              prop="Date"
              :label="$t('Lawsutis.Date')"
              width="200"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope?.row.date }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Category"
              :label="$t('Lawsutis.CaseType')"
              width="200"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row?.category }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="Title"
              :label="$t('Lawsutis.Title')"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row?.title }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="CaseNo"
              :label="$t('Lawsutis.CaseNo')"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row?.caseNo }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="Count" label="Court" align="left" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.court }}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="CauseofAciton"
              :label="$t('Lawsutis.CauseofAction')"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{
                  scope.row?.causeOfAction
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="page_i_box">
            <Page
              :totalFont="true"
              :total="page.total"
              :pageSize.sync="page.pageSize"
              :currentPage="page.pageNo"
              @onPageChange="onPageChangeList"
            ></Page>
            <div class="search_rsult_txt line_2">
              {{ page.pageNo }}-{{ page.pageSize }} of over
              <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results for "{{
                $t("Lawsutis.Litigations")
              }}"
            </div>
          </div>
        </div>
      </div>
    </gui_card>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getLawsuits, getCompanyLawsuitsByPage } from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../Performance/components/table.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import Page from "@/components/page/index.vue";
//importEnd

export default {
  name: "",

  props: {},

  components: {
    // gui_card start
    gui_card,
    // gui_card end

    rectcard,
    content_text,
    tableVue,
    ReLogin,
    Page,
  },

  data() {
    return {
      reLoginVis: false,
      ImporttableData: [],
      newDialog: false,
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      PageImporttableData: [],
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },

  computed: {},
  mounted() {
    this.getLawsuitsList();
    this.pageList();
  },
  methods: {
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.pageList();
    },
    pageList() {
      getCompanyLawsuitsByPage({
        id3a: this.$route.query.id3a,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.ImporttableData = res.data.rows;
          this.page.total = res.data.total;
        } else {
          this.ImporttableData = [];
        }
      });
      // this.PageImporttableData = this.ImporttableData.filter((item, index) => index < this.page.pageNo * this.page.pageSize && index >= this.page.pageSize * (this.page.pageNo - 1));
      // this.page.total = this.ImporttableData.length;
    },
    getLawsuitsList() {
      getLawsuits({ id3a: this.$route.query.id3a })
        .then((Res) => {
          if (Res.code == 200) {
            localStorage.setItem(
              "nineSquareGrid",
              JSON.stringify(Res.data.nineSquareGrid),
            );
            this.$emit("UpdatamarkTotalList", Res.data.nineSquareGrid);
          } else {
            this.ImporttableData = [];
            this.$emit("UpdatamarkTotalList", []);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
  },
};
</script>
<style scoped>

.operations-head{
  color: #1290c9;
}

.table-biao {
  height: auto;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 10px;
}

::v-deep .el-table .cell {
  color: #1a2332;
  font-family: "Arial Bold";
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
}

::v-deep .highlight-cell {
  background-color: #f2f5f9 !important;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
  font-family: "Arial Bold";
  height: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

::v-deep.el-table td.el-table__cell {
  font-family: "Arial Bold";
  height: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

.uc1096 {
  height: 100%;
}

.table-content {
  font-size: 18px;
  color: #1a2332;
}
.uUIRzUi {
  padding: 30px 40px;
}

::v-deep.el-table .cell.el-tooltip {
  white-space: normal;
}

@media screen and (max-width: 1920px) {
  .table-content {
    font-size: 16px !important;
  }
  ::v-deep .el-table .cell {
    line-height: 22px;
    padding-left: 7px;
    padding-right: 7px;
  }

  ::v-deep .el-table th.el-table__cell {
    height: 44px;
    padding-left: 15px;
    padding-right: 15px;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 50px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .uUIRzUi {
    padding: 22px 30px;
  }
}
@media (max-width: 1439px) {
  .table-content {
    font-size: 12px;
  }
  ::v-deep .el-table .cell {
    line-height: 20px;
    padding-left: 6px;
    padding-right: 6px;
  }

  ::v-deep .el-table th.el-table__cell {
    height: 34px;
    padding-left: 14px;
    padding-right: 14px;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 34px;
    padding-left: 14px;
    padding-right: 14px;
  }
  .uUIRzUi {
    padding: 20px 26px;
  }
}
</style>
